<i18n>
de:
</i18n>
<template>

  <v-footer :color="color" class="grey--text" app>
    <!-- The OpenLayers attribution control renders itself in here; Map.vue
         points it at this id. It has to sit outside the map viewport: the
         layer list and the routing panel are open by default and overlay both
         bottom corners of the map, which would leave the map credit invisible
         until the user closes a panel. The OSMF attribution guidelines allow
         the credit next to the map, but not one you have to uncover. -->
    <div id="wgu-attribution" class="wgu-attribution"></div>
    <v-spacer></v-spacer>
    <span class="wgu-footer-left" v-html="footerTextLeft"></span>
    <div class="wgu-footer-right">
      <span v-html="footerTextRight"></span>
      <span v-if="showCopyrightYear" >&copy; {{ new Date().getFullYear() }}</span>
    </div>
  </v-footer>

</template>

<script>

export default {
  name: 'wgu-app-footer',
  props: {
    color: {type: String, required: false, default: 'red darken-3'},
    footerTextLeft: {type: String, required: false, default: 'Powered by <a href="https://meggsimum.de/wegue/" target="_blank">Wegue WebGIS</a>'},
    footerTextRight: {type: String, required: false, default: 'meggsimum'},
    showCopyrightYear: {type: Boolean, required: false, default: true}
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  /* The attribution control is styled by OpenLayers for a corner of the map -
     absolutely positioned, rounded, with its own backdrop. In the footer it has
     to read as footer text instead. */
  #wgu-attribution .ol-attribution {
    position: static;
    max-width: none;
    padding: 0;
    margin: 0;
    background: none;
    border-radius: 0;
  }

  #wgu-attribution .ol-attribution ul {
    display: inline;
    padding: 0;
    margin: 0;
    /* Not `inherit`: the footer carries Vuetify's grey--text (#9e9e9e), which
       is 2.8:1 against the white footer. The map credit has to be legible, so
       it gets its own colour - #424242 measures 10:1 and clears WCAG AA.
       nowrap keeps it on the footer's single line instead of wrapping and
       being clipped off the bottom of the viewport. */
    color: #424242;
    font-size: inherit;
    text-shadow: none;
    white-space: nowrap;
  }

  #wgu-attribution .ol-attribution li {
    display: inline;
    list-style: none;
  }

  #wgu-attribution .ol-attribution a {
    color: #424242;
    text-decoration: underline;
  }

  /* Nothing to credit yet - do not leave an empty gap in the footer. */
  #wgu-attribution .ol-attribution.ol-hidden {
    display: none;
  }

  .wgu-footer-left {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  /* The spacer sits left of these two, so they need their own gap. */
  .wgu-footer-right {
    margin-left: 1em;
    white-space: nowrap;
  }

  /* On a phone the footer cannot hold both credits on one line. The map credit
     is the one that has to be there, so the "powered by" line gives way and the
     credit shrinks to a size that still fits - it keeps its 10:1 contrast. */
  @media (max-width: 600px) {
    .wgu-footer-left {
      display: none;
    }

    #wgu-attribution .ol-attribution ul {
      font-size: 11px;
    }
  }
</style>



// WEBPACK FOOTER //
// app/components/AppFooter.vue